import React from 'react';
import {
  BackWaxCostDivider,
  ForMenHero,
  MenBackAndShoulder,
  MenChestAndStomach,
  MenOtherAreas,
  Men_BA_Divider,
  NeckFaceEar,
  WithoutBackHairDivider,
  SEO,
  BodyAreasStructuredData,
} from '../../components';
import { graphql } from 'gatsby';

function ForMenPage() {
  return (
    <main id='for-men-page'>
      <ForMenHero />
      <WithoutBackHairDivider />
      <MenBackAndShoulder />
      <Men_BA_Divider />
      <MenChestAndStomach />
      {/* <SectionDivider /> */}
      <NeckFaceEar />
      <BackWaxCostDivider />
      <MenOtherAreas />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.site.siteMetadata;
  const title = `${query.service} for Men | ${query.vertical}`;
  const description = `Say goodbye to hairy situations and hello to smooth, confident skin with our laser hair removal for men. Unleash your inner suave and book your appointment today!`;
  const heroImage = `${query.siteUrl}/images/areas/men/Mens_Hero_LG.webp`;
  const url = `${query.siteUrl}/areas/for-men`;
  
  return (
    <>
      <SEO
        location={location}
        origin={query.siteUrl}
        title={title}
        description={description}
      />
      <BodyAreasStructuredData 
        areaName={title}
        location={location}
        areaDescription={description}
        areaImage={heroImage}
        areaUrl={url}
      />
    </>
  );
};

export const query = graphql`
  {
    site {
      siteMetadata {
        siteUrl
        umbrella
        vertical
        service
        title
      }
    }
  }
`;

export default ForMenPage;
